import '../styles/app.scss';
import 'swiper/swiper.css';
import {ready} from "./utils/ready"
import swiper from "./components/swiper"
import checkout from './components/checkout'
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import colorSwatches from "./utils/color-swatches";
import multipleForms from "./components/multipleForms";
import changeTooltipColor from "./utils/change-tooltip-color";
import dynamicPricing from "./utils/dynamic-pricing";

Alpine.plugin(collapse)
Alpine.start()

ready(() => {
    swiper()
    colorSwatches()
    checkout()
    multipleForms()
    changeTooltipColor()
    dynamicPricing()
})